import { useContext } from "react";
import Select from "react-select";
import { UserContext, LanguageContext } from "App";
import { UserTypesArray } from "utils/userConstants";

const UserTypeSelector = ({ value, onChange, placeholder, styles, ...props }) => {
  const CurrentUser = useContext(UserContext);
  const { translations } = useContext(LanguageContext);

  const options = (() => {
    const allOptions = UserTypesArray;
    if (!CurrentUser || !CurrentUser.userType) {
        return [{ value: "Patient", label: "Patient" }];
    }
    
    if (CurrentUser.userType === "Owner") {
      return allOptions;
    }
    if (CurrentUser.userType === "HeadAccounting") {
      return allOptions.filter((opt) => opt.value !== "Owner");
    }
    if (CurrentUser.userType === "Admin") {
      return allOptions.filter(
        (opt) => opt.value !== "Owner" && opt.value !== "HeadAccounting",
      );
    }
    return [{ value: "Patient", label: "Patient" }];
  })();

  const defaultStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      minHeight: "45px",
      fontSize: "1.07rem",
      borderRadius: "8px",
      borderColor: "#d2d6da",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "1.07rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "1.07rem",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder || (translations && translations.CreateUserSelectGenderPlaceholder) || "Select User Type"}
      styles={styles || defaultStyles}
      menuPortalTarget={document.body}
      {...props}
    />
  );
};

export default UserTypeSelector;
